export default __webpack_public_path__ + "static/media/affordable-rides.46af1726.jpeg";